// extracted by mini-css-extract-plugin
module.exports = {"headerLoading":"StageCardLoading_headerLoading__1WE2h","descLoading":"StageCardLoading_descLoading__JmFO_"};